import React from "react";
import {  FaBriefcase, FaClipboardCheck, FaMusic } from "react-icons/fa";
import { SiOpenai } from "react-icons/si";
import { useNavigate } from "react-router-dom";

export default function ProductSelector(){
  const navigate = useNavigate();
  const products = [
    { key: 'stridenext', label: 'StrideNext', icon: <FaBriefcase size={36}/> },
    { key: 'eezeelearn', label: 'eezeelearn', icon: <SiOpenai size={36}/> },
    { key: 'skileval', label: 'Skileval', icon: <FaClipboardCheck size={36}/> },
    { key: 'vugic', label: 'Vugic', icon: <FaMusic size={36}/> },
  ];

  const handleSelect = (p) => {
    // placeholder action
    alert('Selected: ' + p.label);
    // navigate to product route when available
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div className="product-selector-container">
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', maxWidth:900, margin:'20px auto'}}>
        <h2 style={{color:'#2D2B8F'}}>Select a Product</h2>
        <button className="primary" onClick={handleLogout}>Logout</button>
      </div>
      <div className="product-grid">
        {products.map(p => (
          <div key={p.key} className="product-card" onClick={()=>handleSelect(p)}>
            <div className="product-icon">{p.icon}</div>
            <div className="product-label">{p.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
